import { Menu, X } from "lucide-react";
import { useState } from "react";

export default function Navbar() {
	const [menuOpen, setMenuOpen] = useState(false);

	const navLinks = [
		{ label: "Features", href: "#features" },
		{ label: "How it Works", href: "#how-it-works" },
		{ label: "Testimonials", href: "#testimonials" },
		{ label: "Download", href: "#download" },
		{ label: "Contact", href: "#contact" },
	];

	return (
		<nav className="w-full bg-white shadow-sm sticky top-0 z-50">
			<div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">

				<div className="flex flex-col leading-tight">
					<img src="/logoDawi.png" alt="Dawi" className="w-24" />
					<span className="text-xs text-gray-400">Healthcare & More</span>
				</div>

				<ul className="hidden md:flex items-center gap-8">
					{navLinks.map((link) => (
						<li key={link.label}>
							<a
								href={link.href}
								className="text-sm text-gray-600 hover:text-primary transition-colors duration-200"
							>
								{link.label}
							</a>
						</li>
					))}
				</ul>

				<button
					className="md:hidden text-gray-600"
					onClick={() => setMenuOpen(!menuOpen)}
				>
					{menuOpen ? <X size={24} /> : <Menu size={24} />}
				</button>
			</div>

			{menuOpen && (
				<div className="md:hidden bg-white border-t border-gray-100 px-6 py-4">
					<ul className="flex flex-col gap-4">
						{navLinks.map((link) => (
							<li key={link.label}>
								<a
									href={link.href}
									className="text-sm text-gray-600 hover:text-primary"
									onClick={() => setMenuOpen(false)}
								>
									{link.label}
								</a>
							</li>
						))}
					</ul>
				</div>
			)}
		</nav>
	);
}